// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xfnS","footer":"styles_footer__2TiB9","passCodeTooltip":"styles_passCodeTooltip__4AnKP"};